import { render, staticRenderFns } from "./treemap-chart.vue?vue&type=template&id=5e938fa5&"
import script from "./treemap-chart.vue?vue&type=script&lang=js&"
export * from "./treemap-chart.vue?vue&type=script&lang=js&"
import style0 from "./treemap-chart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\projects\\tesas_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('5e938fa5', component.options)
    } else {
      api.reload('5e938fa5', component.options)
    }
    module.hot.accept("./treemap-chart.vue?vue&type=template&id=5e938fa5&", function () {
      api.rerender('5e938fa5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/treemap-chart.vue"
export default component.exports